export default __webpack_public_path__ + "static/media/5C7SX800.39d23200.png";